<template>
  <section class="TcEventsMyCalendar">
    <nav class="tabs my-5">
      <span @click="$root.setPage('events-list')" class="tab">Listado</span>
      <span class="tab active">Mis inscripciones</span>
    </nav>
    <div class="w-1/2 mx-auto">
      <TcEventItem class="mb-3" v-for="event in my_events" :key="event.id" :event="event" :subscribed="true" :hide_buttons="true"></TcEventItem>
    </div>
  </section>
</template>

<script>
import TcEventItem from './TcEventItem.vue';
import eventsMixin from '../mixin/eventsMixin';
export default {
  name: 'TcEventsMyCalendar',
  components: {
    TcEventItem,
  },
  data () {
    return {

    }
  },
  mixins: [
    eventsMixin,
  ],
  created () {
    this.loadMyEvents();
  },
}
</script>